import { brand, memo, updatedAt } from '@/pages/menu-managements/const';
import { Title } from '@/pages/menu-managements/services/title';

export type CategoryForm = typeof brandCategoryForm;

const titleJa = {
  key: 'name',
  label: 'カテゴリ名',
};

export const brandCategoryForm = {
  brand,
  titleJa,
  memo,
} as const;

const tableColumns = [
  {
    ...titleJa,
    width: '200px',
  },
  {
    ...memo,
    width: '200px',
  },
  {
    ...updatedAt,
    width: '180px',
  },
] as const;

export const brandCategoryTableThs = tableColumns.map((tableColumn) => {
  return {
    label: tableColumn.label,
    minWidth: tableColumn.width,
  };
});

export type MenuManagementBrandCategory = {
  id: number;
  title: Title;
  memo: string | null;
  updated_at: Date;
};
